import React from 'react';

/**
 * Reusable Card Component.
 * Provides a consistent container for content with a clean, officious design.
 * Styled entirely with Tailwind CSS.
 *
 * @param {object} props - Component props.
 * @param {React.ReactNode} props.children - The content to be displayed inside the card.
 * @param {string} [props.className=''] - Additional custom Tailwind classes to apply to the card.
 */
export default function Card({ children, className = "", ...rest }) {
    return (
        <div className={`bg-white rounded-xl shadow-sm border border-gray-medium p-6 ${className}`}
        {...rest}>
            {/* {...rest} forwards onClick, onMouseDown, tabIndex etc from where this component is reused */}
            {children}
        </div>
    );
}
